LS.util.route({
	'account': {
		'$guard:eval': {
			'searches': {
				'$index': {
					':load': 'account.searches',
					':unload': 'account.searches:unload'
				}
			}
		}
	}
});